import React from 'react'
import { Row, Col } from "react-bootstrap";
import { PageLinks } from '../../../common/site/page-static-links'
import { Link } from 'gatsby'

const AreaGuideDetails = ({ popularSearchDetailsObject }) => {
    let { area } = popularSearchDetailsObject
    let areaUrl = ""
    let areaText = ""
    let lastcolumnareaText = ""
    if (area) {
        areaUrl = area.toLowerCase().replaceAll(" ", "-")
        areaText = `in ${area}`
        lastcolumnareaText = area
        areaUrl = `in-${areaUrl}`
    }

    return (
        <div className={`row`}>
            <Col xl={3}>
                <ul className='list-unstyled popular-searches-list'>
                    <li><Link to={`/properties/for-sale/${areaUrl ? areaUrl + "/" : ""}`}>Property for sale {areaText}</Link></li>
                    <li><Link to={`/properties/for-sale/${areaUrl ? areaUrl + "/" : ""}type-house/`}>Houses for sale {areaText}</Link></li>
                    <li><Link to={`/properties/for-sale/${areaUrl ? areaUrl + "/" : ""}type-apartments/`}>Apartments for sale {areaText}</Link></li>
                    <li><Link to={`/properties/for-sale/${areaUrl ? areaUrl + "/" : ""}type-bungalow/`}>Bungalows for sale {areaText}</Link></li>
                </ul>
            </Col>
            <Col xl={3}>
                <ul className='list-unstyled popular-searches-list'>
                    <li><Link to={`/properties/to-rent/${areaUrl ? areaUrl + "/" : ""}`}>Property to rent {areaText}</Link></li>
                    <li><Link to={`/properties/to-rent/${areaUrl ? areaUrl + "/" : ""}type-house/`}>Houses to rent {areaText}</Link></li>
                    <li><Link to={`/properties/to-rent/${areaUrl ? areaUrl + "/" : ""}type-apartments/`}>Apartments to rent {areaText}</Link></li>
                    <li><Link to={`/properties/to-rent/${areaUrl ? areaUrl + "/" : ""}type-bungalow/`}>Bungalows to rent {areaText}</Link></li>
                </ul>
            </Col>
            <Col xl={3}>
                <ul className='list-unstyled popular-searches-list'>
                    <li><a href={`/${PageLinks.about}/`}>About us</a></li>
                    <li><a href={`/${PageLinks.team}/`}>Meet the team</a></li>
                    <li><a href={`/${PageLinks.news}/`}>Latest property news</a></li>
                    <li><a href={`/${PageLinks.career}/`}>Careers</a></li>
                </ul>
            </Col>
            <Col xl={3}>
                <ul className='list-unstyled popular-searches-list'>
                    <li><Link to={`/${PageLinks.buyProperty}/`}>Property services {areaText}</Link></li>
                    <li><Link to={`/${PageLinks.contact}/`}>Estate agents {areaText}</Link></li>
                    <li><Link to={`/${PageLinks.career}/`}>Estate agent jobs {areaText}</Link></li>
                    <li><Link to={`/${PageLinks.valuation}/`}>Property valuation {areaText}</Link></li>
                </ul>
            </Col>
        </div>
    )
}

export default AreaGuideDetails